const NOTES_PREFIX = 'lesson_note_';

const getNoteKey = (subject, weekday, timeSlot, group) => {
  return `${NOTES_PREFIX}${[subject, weekday, timeSlot, group].map(v => String(v || '').trim().toLowerCase().replace(/\s+/g, '_')).join('__')}`;
};

export const saveNote = ({ subject, weekday, timeSlot, group, noteText, homework }) => {
  const key = getNoteKey(subject, weekday, timeSlot, group);
  let existing = null;
  try { const raw = localStorage.getItem(key); if (raw) existing = JSON.parse(raw); } catch {}
  const oldHomework = existing?.homework || '';
  const newHomework = homework || '';
  const data = {
    noteText: noteText || '',
    homework: newHomework,
    updatedAt: Date.now(),
    homeworkTargetDate: (newHomework && newHomework !== oldHomework) ? null : (existing?.homeworkTargetDate || null),
  };
  localStorage.setItem(key, JSON.stringify(data));
  return data;
};

export const loadNote = ({ subject, weekday, timeSlot, group }) => {
  const key = getNoteKey(subject, weekday, timeSlot, group);
  const raw = localStorage.getItem(key);
  if (!raw) return null;
  try { return JSON.parse(raw); } catch { return null; }
};

export const deleteNote = ({ subject, weekday, timeSlot, group }) => {
  localStorage.removeItem(getNoteKey(subject, weekday, timeSlot, group));
};

export const loadAllNotes = () => {
  const result = {};
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith(NOTES_PREFIX)) {
      try { result[key] = JSON.parse(localStorage.getItem(key)); } catch {}
    }
  }
  return result;
};

export const getLessonNoteKey = (subject, weekday, timeSlot, group) => getNoteKey(subject, weekday, timeSlot, group);

export const clearAllNotes = () => {
  const keys = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith(NOTES_PREFIX)) keys.push(key);
  }
  keys.forEach(k => localStorage.removeItem(k));
  return keys.length;
};

export const getNotesCount = () => {
  let count = 0;
  for (let i = 0; i < localStorage.length; i++) {
    if (localStorage.key(i)?.startsWith(NOTES_PREFIX)) count++;
  }
  return count;
};

export const findHomeworkBySubject = (allNotes, subject, group) => {
  if (!allNotes || !subject) return null;
  const normalizedSubject = subject.trim().toLowerCase().replace(/\s+/g, '_');
  const normalizedGroup = (group || '').trim().toLowerCase().replace(/\s+/g, '_');
  let latestResult = null;
  let latestTimestamp = 0;
  for (const [key, note] of Object.entries(allNotes)) {
    if (!note || !note.homework) continue;
    const parts = key.replace(NOTES_PREFIX, '').split('__');
    if (parts.length < 4) continue;
    if (parts[0] === normalizedSubject && parts[3] === normalizedGroup) {
      if (note.updatedAt > latestTimestamp) {
        latestTimestamp = note.updatedAt;
        latestResult = {
          homework: note.homework, updatedAt: note.updatedAt,
          homeworkTargetDate: note.homeworkTargetDate || null, sourceKey: key,
        };
      }
    }
  }
  return latestResult;
};

export const markHomeworkDelivered = (sourceKey, targetDateISO) => {
  try {
    const raw = localStorage.getItem(sourceKey);
    if (!raw) return;
    const note = JSON.parse(raw);
    note.homeworkTargetDate = targetDateISO;
    localStorage.setItem(sourceKey, JSON.stringify(note));
  } catch {}
};
